import { render, staticRenderFns } from "./ShopSpecialRefund.vue?vue&type=template&id=30c24ee0&scoped=true&lang=pug&"
import script from "./ShopSpecialRefund.vue?vue&type=script&lang=ts&"
export * from "./ShopSpecialRefund.vue?vue&type=script&lang=ts&"
import style0 from "./ShopSpecialRefund.vue?vue&type=style&index=0&id=30c24ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c24ee0",
  null
  
)

export default component.exports